export default "__VITE_ASSET__Dqh06awV__"